import dayjs from "dayjs";

export const UI_DATE_FORMAT = "DD/MM/YYYY";
export const todayInput = () => dayjs().format("YYYY-MM-DD");
export const formatDate = (value?: string | Date | null) => value ? dayjs(value).format(UI_DATE_FORMAT) : "";
